module.exports = require('react/lib/ReactDefaultPerf');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-addons-perf/index.js
 ** module id = 900
 ** module chunks = 0
 **/